let form = null;

function validateEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}

const checkFormAndSubmit = function(event){
    event.preventDefault();

    const form = document.getElementById('mc-embedded-subscribe-form');
    let isEmail = false;
    let checked = false;
    let email = null;

    const emailInput = form.querySelector('[name=EMAIL]');
    const emailCheck = form.querySelector('#gdpr_52633');
    if(form !== null){
        if(emailInput !== null){
            isEmail = validateEmail( emailInput.value);
            email = emailInput.value;
        }
        if(emailCheck !== null){ 
            checked = emailCheck.checked;
        }
    }
    if(!isEmail){
        const notCorrect = document.getElementById('error_div');
        if(notCorrect !== null){
            notCorrect.innerHTML = 'Please insert a valid Email';
            notCorrect.classList.add('active');
        }   
    }
}
const hideMessages = function(isCheckBox){
    const emailCheck = form.querySelector('#gdpr_52633');
    const notCorrect = document.getElementById('error_div');
    notCorrect.classList.remove('active');
    const success = document.getElementById('mce-success-response');
    const error = document.getElementById('mce-error-response');
    success.style.display = 'none';
    error.style.display = 'none';
    if(!isCheckBox){
        const checkMask = document.getElementById('dot');
        checkMask.classList.remove('full');
        emailCheck.checked = false;
    }
}

const hideNotCorrect = function (event) {
    const notCorrect = document.getElementById('error_div');
    if (notCorrect !== null) {
        notCorrect.classList.remove('active');
        hideMessages(false);
    }
}

const handleCheckMask = function(event){
    const classList = document.getElementById('dot').classList;
    const emailCheck = document.getElementById('gdpr_52633');
    hideMessages(true);
    if(emailCheck.checked){
        classList.add('full');
    }else{
        classList.remove('full');
    }
}


export const handleForm = function(){
    form = document.getElementById('mc-embedded-subscribe-form');
    if(form !== null){
        form.addEventListener('submit', checkFormAndSubmit);
        const emailInput = form.querySelector('[name=EMAIL]');
        emailInput.addEventListener('click', hideNotCorrect);
        emailInput.addEventListener('input', hideNotCorrect);
        const emailCheck = document.getElementById('gdpr_52633');
        emailCheck.addEventListener('change', handleCheckMask)
    }
}
